




import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class WritingTask2 extends Vue {}
